import React from 'react';

import { Resources } from '@ragu-components/ord-resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { Extension } from '@ragu-components/ord-types';

const ExtensionsList = React.lazy(async () => import('./ExtensionsList'));

export const extensionResource: OrdResourceProps = {
  key: Resources.extensions,
  name: Resources.extensions,
  list: <ExtensionsList />,
  options: {},
  recordRepresentation: (record: Extension): string => record.number,
};
